import React, { useState } from "react";
import { Row, Col, Spin, Form, Card, DatePicker } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import { Tooltip } from "antd";
import { connect } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";

import MainLayout from "../../../../components/layouts/enhancement/MainLayout";
import TopContent from "../../../../components/layouts/enhancement/TopContent";
import cnt from "../../../../services/definedConstant";
import { rightAction } from "../../../../redux/actions";
import {
  labelConfig,
  staticConfig,
  apiConfig,
} from "../../treasuryContractBooking.config";
import { BOM } from "../../../../services/definedMethod";

const CloseContract = (props) => {
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const contractId = location.state;

  const { userData } = props;
  const { session } = userData || {};

  const onFinish = (values) => {
    setIsLoading(true);

    const body = {
      session,
      locale: "en",
      dateFormat: "dd MMMM yyyy",
      closeOnDate: values.closeOnDate?.format("DD MMMM YYYY"),
      method: "POST",
    };

    const url = `${apiConfig.GetTreasuryBillContract}/${contractId}/close`;

    BOM.FetchReqAction(body, url, (err) => {
      if (err) {
        BOM.AlertMsg(
          cnt.DANGER,
          err?.errors?.[0]?.defaultUserMessage ||
            err?.defaultUserMessage ||
            "Failed to close contract."
        );
        setIsLoading(false);
        return;
      }

      BOM.AlertMsg(cnt.SUCCESS, "Contract closed successfully.");
      setIsLoading(false);
      navigate(-1);
    });
  };

  return (
    <MainLayout pageItems={staticConfig.managetreasuryBillContract}>
      <TopContent pageTitle={labelConfig.treasuryBillContract} />

      <Spin spinning={isLoading} size="large">
        <div style={{ padding: "24px" }}>
          <Card
            style={{
              boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
              borderRadius: 20,
            }}
          >
            {/* Warning banner */}
    

            <h3 style={{ marginBottom: 4, fontWeight: 600 }}>
              Close Contract
            </h3>
            <p style={{ color: "#667085", fontSize: 14, marginBottom: 24 }}>
              Provide the date on which this treasury bill contract should be
              closed.
            </p>

            <Form layout="vertical" form={form} onFinish={onFinish}>
              <Row>
                {/* Close On Date */}
                <Col span={12} style={{ padding: "0 8px" }}>
                  <Form.Item
                    label={
                      <span>
                        Close On Date{" "}
                        <Tooltip title="The date on which this contract is officially closed.">
                          <InfoCircleOutlined
                            style={{ marginLeft: 4, color: "#667085" }}
                          />
                        </Tooltip>
                      </span>
                    }
                    name="closeOnDate"
                    rules={[
                      { required: true, message: "Close date is required" },
                    ]}
                  >
                    <DatePicker
                      style={{ width: "100%", height: 44 }}
                      format="YYYY-MM-DD"
                      placeholder="YYYY-MM-DD"
                    />
                  </Form.Item>
                </Col>
              </Row>

              <div
                style={{
                  borderTop: "1px solid #EAECF0",
                  margin: "8px 0 20px",
                }}
              />

              <Row justify="end">
                <Col>
                  <button
                    type="button"
                    onClick={() => navigate(-1)}
                    style={{
                      height: 44,
                      padding: "0 24px",
                      borderRadius: 8,
                      border: "1px solid #D0D5DD",
                      background: "#fff",
                      color: "#344054",
                      fontWeight: 600,
                      fontSize: 14,
                      cursor: "pointer",
                      marginRight: 12,
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    onClick={() => form.submit()}
                    style={{
                      height: 44,
                      padding: "0 24px",
                      borderRadius: 8,
                      border: "1px solid #B42318",
                      background: "#B42318",
                      color: "#fff",
                      fontWeight: 600,
                      fontSize: 14,
                      cursor: "pointer",
                    }}
                  >
                    Close Contract
                  </button>
                </Col>
              </Row>
              <button type="submit" hidden />
            </Form>
          </Card>
        </div>
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  rightBtn: state.RightSideBtn,
  userData: state.AuthenticationData.userData,
});

export default connect(mapStateToProps, { rightAction })(CloseContract);